module.exports = __webpack_public_path__ + "static/media/2022backtoschool.89cbdc9d.png";